import React from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../constants/routes';

export default () => (
    <div className={styles.page}>
        <div className={styles.contentContainer}>
            <h1 className={styles.mainTitle}>Loan Calculator</h1>
            <Link
                key='button'
                to={`${process.env.PUBLIC_URL}/loan${Routes.STEPONE}`}
                rel='nofollow'
                className={styles.button}
                title='Button Title'
            >
                Button
            </Link>
        </div>
    </div>
);
